import { useApiClient } from "@myplant-io/utils/api";
import { useQuery } from "react-query";
import { MemoryItem } from "../types";

export function useMemoryItems() {
  const client = useApiClient();
  return useQuery("memory", () => client.fetch<MemoryItem[]>("/api/memory"));
}
